export function isAbsoluteHref(href: string) {
   return /^(?:[a-z]+:)?\/\//i.test(href);
}

export function isRelativeHref(href: string) {
   return !isAbsoluteHref(href);
}

export function isIFixitUSUrl(url: URL) {
   return isIfixitUrl(url) || isCominorUrl(url);
}

export function isIfixitUrl(url: URL) {
   return /^(?:www\.)?ifixit\.com$/.test(url.hostname);
}

export function isCominorUrl(url: URL) {
   return /^(?:[^.]+\.)?cominor\.com$/.test(url.hostname);
}

export function isNextJsPath(path: string) {
   return (
      /^\/cart\/?$/.test(path) ||
      /^\/Store(?:\/.*)?$/.test(path) ||
      /^\/Support\/?$/.test(path) ||
      /^\/Parts(?:\/.*)?$/.test(path) ||
      /^\/Tools(?:\/.*)?$/.test(path) ||
      /^\/go\/[^/]+\/?$/.test(path) ||
      /^\/Shop\/[^/]+\/?$/.test(path) ||
      /^\/products\/[^/]+\/?$/.test(path) ||
      /^\/Troubleshooting\/[^/]+\/?$/.test(path) ||
      /^\/Troubleshooting(?:\/[^/]+){3}\/?$/.test(path) ||
      /^\/pro\/?(?:\?.*)?$/.test(path) ||
      /^\/go\/workbench(?:\/.*)?$/.test(path)
   );
}

export function getCookieDomain(url?: URL | Location): string {
   return getCookieDomainFromHost(url?.hostname || '');
}

export function getCookieDomainFromHost(hostname: string): string {
   // Browsers reject `domain=.localhost`; attach the cookie host-only by
   // returning the bare hostname.
   if (hostname === 'localhost') return hostname;
   const currentDomain = hostname.split('.').splice(-2).join('.');
   // vercel.app is a public suffix, so we cannot use it as a valid cookie domain
   // https://vercel.com/guides/can-i-set-a-cookie-from-my-vercel-project-subdomain-to-vercel-app
   return currentDomain === 'vercel.app' ? hostname : '.' + currentDomain;
}
